import React, { useEffect, useState } from 'react';
import { properties } from '../../properties';
import SoapResponse from '../SoapResponse';
import ErrorPage from '../../ErrorPage';
import LoaderComp from '../LoaderComp';
import transidgenerator from '../../transidgenerator';
import $ from "jquery";

function SoapTokenAuth({ apiUrl }) {
    const [soapTokenAuth, setSoapTokenAuth] = useState({
        operation: properties.OPERATIONS.tokenauth,
        vendorid: properties.VENDOR_ID,
        userid: properties.USER_ID,
        transactionid: transidgenerator(),
        method: properties.SOAP_METHOD,
        customerPresent: properties.CUSTOMER_PRESENT,
        token: properties.TOKEN,
        description: properties.DESCRIPTION,
        value: properties.VALUE,
        currency: properties.CURRENCY,
        timestamp: "",
        region: properties.SEL_REGION,
        postCode: properties.POST_CODE,
        address: properties.ADDRESS,
        countryCode: properties.COUNTRY_CODE,
        allowCscFail: properties.ALLOW_CSC_FAIL,
        allowAvsFail: properties.ALLOW_AVS_FAIL,
        password: properties.PASSWORD,
        security: ""
    });
 
    var canSubmit = true;
 
    function isNotNullCheck(e, field){
        if(e === "" || !e){
            document.getElementsByName(field)[0].classList.add("emptied");
            document.getElementsByName(field)[1].classList.add("emptied");
            canSubmit = false;
        }
        else{
            document.getElementsByName(field)[0].classList.remove("emptied");
            document.getElementsByName(field)[1].classList.remove("emptied");
        }
    }

    useEffect(() => {
        $(".page-body").scrollTop(0);
    },[]);

    const [response, setResponse] = useState();

    function changeTransactionId(e) {
        isNotNullCheck(e.target.value,"WPG_transID");
        setSoapTokenAuth({ ...soapTokenAuth, transactionid: e.target.value });
    }

    function changeVendorId(e) {
        isNotNullCheck(e.target.value,"WPG_vendorID");
        setSoapTokenAuth({ ...soapTokenAuth, vendorid: e.target.value });
    }

    function changePwd(e) {
        isNotNullCheck(e.target.value,"vendorPwd");
        setSoapTokenAuth({ ...soapTokenAuth, password: e.target.value });
    }

    function changeDesc(e) {
        isNotNullCheck(e.target.value,"WPG_description");
        setSoapTokenAuth({ ...soapTokenAuth, description: e.target.value });
    }

    function changeUserId(e) {
        setSoapTokenAuth({ ...soapTokenAuth, userid: e.target.value });
    }

    function changeCustomerPresent(e) {
        isNotNullCheck(e.target.value,"WPG_customerPresent");
        setSoapTokenAuth({ ...soapTokenAuth, customerPresent: e.target.value });
    }

    function changeMethod(e) {
        isNotNullCheck(e.target.value,"WPG_method");
        setSoapTokenAuth({ ...soapTokenAuth, method: e.target.value });
    }

    function changeAllowCscFail(e) {
        setSoapTokenAuth({ ...soapTokenAuth, allowCscFail: e.target.value });
    }

    function changeValue(e) {
        isNotNullCheck(e.target.value,"WPG_value");
        setSoapTokenAuth({ ...soapTokenAuth, value: e.target.value });
    }

    function changeCurrency(e) {
        isNotNullCheck(e.target.value,"WPG_currency");
        setSoapTokenAuth({ ...soapTokenAuth, currency: e.target.value });
    }

    function changeToken(e) {
        isNotNullCheck(e.target.value,"WPG_token");
        setSoapTokenAuth({ ...soapTokenAuth, token: e.target.value });
    }

    function changeAddr(e) {
        setSoapTokenAuth({ ...soapTokenAuth, address: e.target.value });
    }

    function changePostCode(e) {
        setSoapTokenAuth({ ...soapTokenAuth, postCode: e.target.value });
    }

    function changeCountryCode(e) {
        setSoapTokenAuth({ ...soapTokenAuth, countryCode: e.target.value });
    }

    function changeRegion(e) {
        isNotNullCheck(e.target.value,"WPG_region");
        setSoapTokenAuth({ ...soapTokenAuth, region: e.target.value });
    }

    function changeAllowAvsFail(e) {
        setSoapTokenAuth({ ...soapTokenAuth, allowAvsFail: e.target.value });
    }

    var region =[];
 
    for(var property in properties.REGIONS){
        region.push(<option value={property} key={property}>{properties.REGIONS[property]}</option>);
    }

    async function submitTokenAuthForm(e) {
        e.preventDefault();
        isNotNullCheck(soapTokenAuth.transactionid,"WPG_transID");
        isNotNullCheck(soapTokenAuth.vendorid,"WPG_vendorID");
        isNotNullCheck(soapTokenAuth.password,"vendorPwd");
        isNotNullCheck(soapTokenAuth.description,"WPG_description");
        isNotNullCheck(soapTokenAuth.method,"WPG_method");
        isNotNullCheck(soapTokenAuth.customerPresent,"WPG_customerPresent");
        isNotNullCheck(soapTokenAuth.value,"WPG_value");
        isNotNullCheck(soapTokenAuth.region,"WPG_region");
        isNotNullCheck(soapTokenAuth.token,"WPG_token");
        isNotNullCheck(soapTokenAuth.currency,"WPG_currency");
        soapTokenAuth.timestamp = Math.floor(Date.now() / 1000);
        var md5 = require('md5');
        const requestbody =
        {
            vendorID: soapTokenAuth.vendorid,
            transID: soapTokenAuth.transactionid,
            userID: soapTokenAuth.userid,
            method: soapTokenAuth.method,
            customerPresent: soapTokenAuth.customerPresent,
            token: soapTokenAuth.token,
            description: soapTokenAuth.description,
            value: soapTokenAuth.value,
            currency: soapTokenAuth.currency,
            timestamp: soapTokenAuth.timestamp,
            region: soapTokenAuth.region,
            AVSPost: soapTokenAuth.postCode,
            AVSAddr: soapTokenAuth.address,
            countryCode: soapTokenAuth.countryCode,
            allowCSCFail: soapTokenAuth.allowCscFail,
            allowAVSFail: soapTokenAuth.allowAvsFail,
            security: md5( soapTokenAuth.vendorid +
                soapTokenAuth.transactionid + soapTokenAuth.userid + soapTokenAuth.method +
                soapTokenAuth.customerPresent + soapTokenAuth.token + soapTokenAuth.description +
                soapTokenAuth.value + soapTokenAuth.currency + soapTokenAuth.timestamp + soapTokenAuth.region +
                soapTokenAuth.address + soapTokenAuth.postCode +
                soapTokenAuth.countryCode + soapTokenAuth.allowCscFail +
                soapTokenAuth.allowAvsFail + soapTokenAuth.password),
        };
        var xmlBody = [];
        xmlBody.push(properties.SOAP_REQUEST_PREFIX + "<ns1:tokenAuthorise>");
        for (var property in requestbody) {
            xmlBody.push("<" + property + ">" + requestbody[property] + "</" + property + ">");
        }
        xmlBody.push("</ns1:tokenAuthorise>" + properties.SOAP_REQUEST_SUFFIX);
        xmlBody = xmlBody.join("\n");
        var request = {
            method: 'POST',
            headers: new Headers({
                'Accept-Type': 'text/xml',
                'Content-Type': 'text/xml'
            }),
            body: xmlBody
        };
        if(canSubmit){
            document.getElementsByClassName("loader")[0].classList.add("loading");
            if(soapTokenAuth.region === "NoR"){
                setSoapTokenAuth({...soapTokenAuth, region:""});
            }
            var statusCode;
            fetch(apiUrl, request)
            .then(resp => {
                if(Object.keys(properties.RESPONSE_STATUS_MESSAGE).indexOf(String(resp.status)) === -1){
                    return resp.text();
                }
                else{
                    statusCode = resp.status;
                    throw resp;
                }
            })
            .then(responsedata => setResponse(<SoapResponse title="Token Authorise Response" operation="WPG_tokenauth" message={responsedata} />))
            .catch((error)=>{
                console.log(error);
                setResponse(<ErrorPage code={statusCode} />);
            });
        }
    }
        

    var soapTokenAuthTemplate = (
        <div className="operation-form">
            <h2>Token Authorise</h2>
            <form className="form-horizontal" method='post' onSubmit={submitTokenAuthForm}>

                <div className="form-group">
                    <div className="control-label">
                        Client Application ID<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_vendorID" value={soapTokenAuth.vendorid} onChange={changeVendorId} />
                        <div className="error-msg" name="WPG_vendorID">Client Application ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Transaction ID<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_transID" value={soapTokenAuth.transactionid} onChange={changeTransactionId} />
                        <div className="error-msg" name="WPG_transID">Transaction ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        User ID
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_userid" value={soapTokenAuth.userid} onChange={changeUserId} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Customer Present<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_customerPresent" value={soapTokenAuth.customerPresent} onChange={changeCustomerPresent}>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                        <div className="error-msg" name="WPG_customerPresent">Customer Present is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Method<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_method" value={soapTokenAuth.method} onChange={changeMethod} />
                        <div className="error-msg" name="WPG_method">Method is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Description<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_description" value={soapTokenAuth.description} onChange={changeDesc} />
                        <div className="error-msg" name="WPG_description">Description is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Value<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_value" value={soapTokenAuth.value} onChange={changeValue} />
                        <div className="error-msg" name="WPG_value">Value is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        ISO Currency Code<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_currency" value={soapTokenAuth.currency} onChange={changeCurrency} />
                        <div className="error-msg" name="WPG_currency">ISO Currency Code is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Region<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_region" value={soapTokenAuth.region} onChange={changeRegion}>
                            {region}
                        </select>
                        <div className="error-msg" name="WPG_region">Region is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        AVS Post Code
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control"  value={soapTokenAuth.postCode} onChange={changePostCode} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        AVS Address
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control"  value={soapTokenAuth.address} onChange={changeAddr} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        ISO Country Code
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control"  value={soapTokenAuth.countryCode} onChange={changeCountryCode} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Allow CSC Fail
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control"  value={soapTokenAuth.allowCscFail} onChange={changeAllowCscFail}>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Allow AVS Fail
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control"  value={soapTokenAuth.allowAvsFail} onChange={changeAllowAvsFail}>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Token<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_token" value={soapTokenAuth.token} onChange={changeToken} />
                        <div className="error-msg" name="WPG_token">Token is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Client Application Password<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="password" className="form-control" name="vendorPwd" value={soapTokenAuth.password} onChange={changePwd} />
                        <div className="error-msg" name="vendorPwd">Client Application Password is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="col-sm-5">
                        <button type="submit" className="btn btn-primary">Perform</button>
                    </div>
                </div>
            </form>
            <div className="loader-div">
                <span className="loader"><LoaderComp/></span>
            </div>
        </div>

    );

    return response ? response : soapTokenAuthTemplate;
}

export default SoapTokenAuth;